import moment from 'moment';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { TimesheetSubmitted } from 'api/notifications/meta';
import { Causer } from '../causer';
import { ProjectName } from './timesheet-approved';
import { WeekViewLink } from './week-view';

export const TimesheetSubmittedView: FC<{
  meta: TimesheetSubmitted;
  userId: number;
}> = ({ meta: { by, info, start }, userId }) => {
  if (info?.project?.projectId) {
    return (
      <FormattedMessage
        id="notifications.messages.timesheet_submitted.project"
        values={{
          causer: <Causer user={by} />,
          week: (
            <WeekViewLink
              start={moment(start)}
              userId={userId}
              projectId={info?.project?.projectId}
            />
          ),
          project: ProjectName(info.project),
        }}
      />
    );
  }

  return (
    <FormattedMessage
      id="notifications.messages.timesheet_submitted"
      values={{
        causer: <Causer user={by} />,
        week: <WeekViewLink start={moment(start)} userId={userId} />,
      }}
    />
  );
};
